import React from 'react';
import PropTypes from 'prop-types';
import { IllustrationPill } from '../IllustrationPill';
import { StyledIllustrationPillsCRO, Grid } from './styles.js';

export const IllustrationPillsCRO = ({ pills }) => {
  return (
    <StyledIllustrationPillsCRO $bgColor="background.base">
      <Grid gridAmount={pills.length}>
        {pills.map((pill, i) => (
          <IllustrationPill key={i} {...pill} />
        ))}
      </Grid>
    </StyledIllustrationPillsCRO>
  );
};

IllustrationPillsCRO.displayName = 'IllustrationPillsCRO';

IllustrationPillsCRO.propTypes = {
  pills: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};
